export const allClients = 'AllClients';

export const worxit = 'worxit';

export const crusaders = 'crusaders';

export const freedom = 'freedom';